<template>
  <div class="w-full">
    <ProgressionBar v-if="step <= totalSteps" :max="totalSteps" :value="step" />
    <SellerSelectionStep
      v-show="step === 1"
      :key="`seller-${quizKey}`"
      :componentStep="1"
      :currentStep="step"
      :totalQuestions="totalSteps"
      :initialSeller="selectedSeller"
      :quiz="quiz"
      @next="handleNext"
      @previous="step--"
    />
    <Step
      v-for="(question, index) in formattedQuestions"
      :key="`quiz-${quizKey}-${index}`"
      v-show="step === index + 2"
      :componentStep="index + 2"
      :currentStep="step"
      :totalQuestions="totalSteps"
      :themeBadge="question.themeBadge"
      :questionTitle="question.questionTitle"
      :questionSubtitle="question.questionSubtitle"
      :options="question.options"
      :correctAnswer="question.correctAnswer"
      :explanation="question.explanation"
      @next="(data) => handleQuestionNext(data, index)"
      @previous="handlePrevious(index)"
    />
    <TerminationStep
      v-if="step > totalSteps"
      :key="`termination-${quizKey}`"
      :componentStep="totalSteps + 1"
      :currentStep="step"
      :totalQuestions="totalSteps"
      :quizResults="quizResults"
      :selectedSeller="selectedSeller"
      :quizId="quiz.id"
      :answers="attemptAnswers"
      :attemptAlreadySubmitted="attemptSubmitted"
      @previous="step = totalSteps"
      @completed="quizCompleted"
      @retry="handleRetry"
      @submitted="attemptSubmitted = true"
    />
  </div>
</template>

<script>
import SellerSelectionStep from "@/components/quiz/questions/SellerSelectionStep.vue";
import Step from "@/components/quiz/questions/Step.vue";
import TerminationStep from "@/components/quiz/questions/TerminationStep.vue";
import { ProgressionBar } from "@estaly/ui";

export default {
  components: {
    ProgressionBar,
    SellerSelectionStep,
    Step,
    TerminationStep,
  },
  emits: ["completed", "back-to-documentation"],
  props: {
    quiz: {
      type: Object,
      required: true,
    },
    initialSeller: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      step: this.initialSeller ? 2 : 1,
      quizKey: 0,
      correctAnswers: 0,
      sellerName: this.initialSeller?.name || null,
      selectedSeller: this.initialSeller || null,
      attemptAnswers: [],
      attemptSubmitted: false,
    };
  },
  computed: {
    questions() {
      return this.quiz.questions || [];
    },
    totalSteps() {
      return this.questions.length + 1;
    },
    formattedQuestions() {
      return this.questions.map((question) => ({
        themeBadge: question.themeBadge,
        questionTitle: question.title,
        questionSubtitle: question.subtitle,
        options: question.answers.map((a) => a.text),
        correctAnswer: question.answers.findIndex((a) => a.isCorrect),
        explanation: question.explanation,
      }));
    },
    quizResults() {
      return {
        correctAnswers: this.correctAnswers,
        totalQuestions: this.questions.length,
        sellerName: this.sellerName,
      };
    },
  },
  methods: {
    handleNext(data) {
      if (data?.seller) {
        this.selectedSeller = data.seller;
        this.sellerName = data.seller.name || data.seller;
      }
      this.step++;
    },
    handlePrevious(questionIndex) {
      if (questionIndex === 0 && this.initialSeller) {
        this.$emit("back-to-documentation");
      } else {
        this.step--;
      }
    },
    handleQuestionNext(data, questionIndex) {
      if (data) {
        const question = this.questions[questionIndex];
        const existingIndex = this.attemptAnswers.findIndex((a) => a.questionId === question.id);

        if (existingIndex === -1) {
          if (data.isCorrect) this.correctAnswers++;
          const selectedAnswer = question.answers[data.selectedAnswer];
          this.attemptAnswers.push({
            questionId: question.id,
            answerId: selectedAnswer.id,
          });
        }
      }
      this.step++;
    },
    quizCompleted(results) {
      this.$emit("completed", results || this.quizResults);
    },
    handleRetry() {
      this.step = this.initialSeller ? 2 : 1;
      this.correctAnswers = 0;
      this.attemptAnswers = [];
      this.attemptSubmitted = false;
      if (!this.initialSeller) {
        this.selectedSeller = null;
        this.sellerName = null;
      }
      this.quizKey++;
    },
  },
};
</script>
